






















import Vue from 'vue';
import themes from '../../styles/themes';

/**
 * A component that opens a Dialog box (which allows text to be displayed) when the button is
 * clicked on
 */
export default Vue.extend({
  name: 'SInfo',

  components: {
    SActionDialog: () => import('../SActionDialog/SActionDialog.vue'),
  },

  props: {
    /**
     * @deprecated Not used for anything
     */
    id: {
      type: String,
      required: false,
    },

    /**
     * Title that is shown in the Dialog that is opened after clicking on the info icon
     */
    title: {
      type: String,
      required: true,
    },

    /**
     * Description that is shown in the popup
     */
    description: {
      type: String,
      required: false,
    },

    /**
     * Sub description that is shown in the popup
     */
    subDescription: {
      type: String,
      required: false,
    },

    /**
     * The theme applied. This is used to work out the colour of the icon
     */
    theme: {
      type: String,
      default: 'primary',
    },

    /**
     * @see src/components/SActionDialog/SActionDialog.vue#tooltipColor
     */
    tooltipColor: {
      type: String,
      default: 'primary',
    },
  },

  computed: {
    iconColor(): string {
      return themes[this.theme]?.darkHeader ? 'white' : 'black';
    },

    infoTitle(): string {
      return `${this.title} Info`;
    },
  },
});
